<template>
  <div class="collapse-wrapper-container">
    <b-button
      v-b-toggle="generatedId"
      block
      variant="light"
      class="d-flex justify-content-between align-items-center mt-1"
      :disabled="disabled"
      data-cy="collapse-wrapper"
    >
      <div>
        <slot name="title">
          {{ title }}
        </slot>
        <HelpfulTooltip :text="helpfulTip" />
      </div>

      <PremiumFeature
        v-if="showPremiumFeature"
        class="align-self-start"
        :tooltip-text="premiumFeatureText"
      />

      <template v-if="!disabled">
        <font-awesome-icon
          icon="minus"
          class="when-opened"
          style="color: #999;"
        />
        <font-awesome-icon
          icon="plus"
          class="when-closed"
          style="color: #999;"
        />
      </template>
    </b-button>

    <b-collapse
      v-if="!disabled"
      :id="generatedId"
    >
      <b-card>
        <slot />
      </b-card>
    </b-collapse>
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

// @ts-ignore uuid not having types
import { v4 as uuidv4 } from 'uuid'
import HelpfulTooltip from '@/components/builder/UI/HelpfulTooltip.vue'
import PremiumFeature from '@/components/builder/UI/PremiumFeature.vue'
import wrapperProps from '@/components/builder/UI/wrapperProps'

const components = {
  HelpfulTooltip,
  PremiumFeature,
}

const props = wrapperProps

@Component({ components })
export default class CollapseWrapper extends Vue.extend({ props }) {
  generatedId = 'collapse-wrapper-' + uuidv4()
}

</script>
